<div class="content">
  @if (icon || iconName) {
    <ppl-icon
      [svgIcon]="icon || iconName"
      width="18px"
      height="18px"
      [fill]="iconFill"
      class="type-icon"></ppl-icon>
  }

  <div class="box_text">
    @if (textTemplate) {
      <ng-template [ngTemplateOutlet]="textTemplate"></ng-template>
    }
    @if (!textTemplate && text) {
      {{ text }}
    }
  </div>

  <div class="actions">
    @if (enableActions && actionsTemplate) {
      <ng-template [ngTemplateOutlet]="actionsTemplate"></ng-template>
    }
    @if (enableActions && !actionsTemplate && buttonText) {
      <ppl-button
        pplButton
        pplButtonSmall="xs"
        [pplButton7]="type"
        [disabled]="buttonDisabled"
        (click)="buttonClick.emit()"
        >{{ buttonText }}</ppl-button
      >
    }
    @if (enableClose) {
      <ppl-icon
        svgIcon="closering-red2"
        class="box_close"
        width="18px"
        height="18px"
        (click)="close.emit()"></ppl-icon>
    }
  </div>
</div>
@if (drawerOpen) {
  <div class="drawer">
    @if (drawerTemplate) {
      <ng-template [ngTemplateOutlet]="drawerTemplate"></ng-template>
    }
  </div>
}
